/* Andiani — páginas de preparador y de proyecto: aparición al desplazarse y visor de fotos. */
(() => {
  if (window.__andianiProjects) return;
  window.__andianiProjects = true;

  /* Aparición suave al entrar en pantalla (desactivada si se pide reducir movimiento) */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = document.querySelectorAll('[data-an-reveal]');
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('an-reveal-on');
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach((item) => io.observe(item));
  }

  /* Filas de proyectos: arrastrar con el ratón (en táctil ya se deslizan solas) */
  document.querySelectorAll('.an-related__row').forEach((row) => {
    let startX = 0;
    let startScroll = 0;
    let down = false;
    let moved = false;
    row.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = row.scrollLeft;
    });
    row.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        row.classList.add('is-grabbing');
        try { row.setPointerCapture(e.pointerId); } catch (err) { /* sin captura */ }
      }
      if (moved) row.scrollLeft = startScroll - dx;
    });
    const end = () => {
      down = false;
      row.classList.remove('is-grabbing');
    };
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    /* Tras arrastrar, el clic no abre el proyecto */
    row.addEventListener('click', (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
    row.addEventListener('dragstart', (e) => e.preventDefault());
  });

  /* Visor de fotos */
  const dialog = document.querySelector('[data-an-lightbox]');
  const gallery = document.querySelector('[data-an-gallery]');
  if (dialog && gallery) {
    const buttons = [...gallery.querySelectorAll('[data-an-full]')];
    const img = dialog.querySelector('[data-an-lightbox-img]');
    let index = 0;
    const show = (i) => {
      index = (i + buttons.length) % buttons.length;
      img.src = buttons[index].getAttribute('data-an-full');
      img.alt = `Foto ${index + 1} de ${buttons.length}`;
    };
    buttons.forEach((button, i) =>
      button.addEventListener('click', () => {
        show(i);
        dialog.showModal();
      })
    );
    dialog.querySelector('[data-an-lightbox-prev]').addEventListener('click', () => show(index - 1));
    dialog.querySelector('[data-an-lightbox-next]').addEventListener('click', () => show(index + 1));
    dialog.querySelector('[data-an-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
    dialog.addEventListener('close', () => {
      const back = buttons[index];
      if (back) back.focus();
    });
  }
})();
